import backofficeService from '../../api/backoffice'

export default {

  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.assignedToUserID
   * @param {*} params.assignedToMe
   * @param {*} params.reporterUserID
   * @param {*} params.reporteredByMe
   */
  getAll(params) {
    return backofficeService.Api().get('api/task', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllByStore(id) {
    return backofficeService.Api().get(`api/task/store/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllPendingTask(params) {
    return backofficeService.Api().get('api/myPendingTask', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getAllEmployeeTask(params) {
    return backofficeService.Api().get('api/task/count', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getTaskList() {
    return backofficeService.Api().get('api/allPendingTask')
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  taskCompliteReport(params) {
    return backofficeService.Api().get('api/task/report', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  compliteByDay(params) {
    return backofficeService.Api().get('api/task/count/day', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`api/task/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    return backofficeService.Api().post('api/task/create', data)
      .then(response => response.data)
      .catch(error => error)
  },

  getByStoreId(id) {
    return backofficeService.Api().get(`api/task/bystoreId/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getByUserId(id) {
    return backofficeService.Api().get(`api/task/user/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getById(id) {
    return backofficeService.Api().get(`api/task/byID/${id}`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  // getByTask(taskID, params) {
  //   return backofficeService.Api().get(`api/comment/byTask/${taskID}`, { params })
  //     .then(response => response.data)
  //     .catch((error) => { throw error })
  // },
  delete(id) {
    return backofficeService.Api().delete(`api/task/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  }
}
